import Lottie from 'lottie-react';

import lottieSymptomaticFactors from '../jsons/symptomatic-factors.json';

const LottieSymptomaticFactors = props => {
  return <Lottie animationData={lottieSymptomaticFactors} loop={false} {...props} />;
};

export default LottieSymptomaticFactors;
